import Choice from "./Choice.vue"

export default Choice;